import type { ChangeEventHandler } from 'react';
import { Search } from 'lucide-react';

import { cn } from '@/lib/utils';

interface CompactSearchFieldProps {
  value?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
}

/**
 * CompactSearchField — minimal search text field (icon + input).
 */
export function CompactSearchField({
  value,
  onChange,
  placeholder,
  className,
  inputClassName,
}: CompactSearchFieldProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-md border border-sidebar-border bg-sidebar-accent px-2 py-1.5',
        className
      )}
    >
      <Search className="h-3.5 w-3.5 text-muted-foreground" aria-hidden="true" />
      <input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={cn(
          'w-full bg-transparent text-xs font-medium text-sidebar-foreground placeholder:text-muted-foreground',
          'focus:outline-none [&::-webkit-search-cancel-button]:hidden',
          inputClassName
        )}
        type="search"
      />
    </div>
  );
}
